import { Box, Button, DropdownMenu, Flex, Select } from "@radix-ui/themes";
import { useEffect } from "react";
import { FaAngleDown } from "react-icons/fa";


export const DropDownQuestion = ({
  element,
  index,
  onSelect,
  onValidate,
  isMandatory
}: {
  element: any;
  index: number;
  onSelect: (option: any, index: number) => void;
  onValidate?: (index: number, isValid: boolean) => void;
  isMandatory?: boolean;
}) => {
  const getDefault = () => {
    const selected = element.answer.find((el: any) => el.isAnswer);
    return selected ? selected.value : "none"; // Default to "none" for unselected state
  };
  const defaultValue = getDefault();

  useEffect(() => {
    if (isMandatory) {
      onValidate(index, defaultValue !== "none");
    }
  }, [defaultValue, index, isMandatory, onValidate]);

  return (
    <Flex direction="column" justify="center">
      <label className="text-base font-medium mb-3">
        {element.question}
        {element.Mandatory && <span className="text-red-600">*</span>}
      </label>

      <Box>
        <Select.Root
          onValueChange={(value) => {
            if (value !== "none") {
              onSelect(value, index); // Only call onSelect for valid selections
              if (isMandatory) {
                onValidate(index, true); //  mark valid after selection
              }
            } else {
              if (isMandatory) {
                onValidate(index, false); //  invalid if reset to "none"
              }
            }
          }}
          defaultValue={getDefault()}
        >
          <Select.Trigger />
          <Select.Content>
            <Select.Group>
              <Select.Item value="none">Please Select</Select.Item>
              {element.answer.map((item: any) => (
                <Select.Item value={item.value} key={item.answerId}>
                  {item.value}
                </Select.Item>
              ))}
            </Select.Group>
            <Select.Separator />
          </Select.Content>
        </Select.Root>
      </Box>
    </Flex>
  );
};

export default DropDownQuestion